module.exports = __webpack_public_path__ + "img/r6.62a5497f.jpg";